module.exports = __webpack_public_path__ + "img/badge_color_highered-holistic.ab55de02.svg";